
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import {
  Button,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';

const checkRole = (user, roles) => {
  if (!user || !user.role) return false;
  return roles.includes(user.role);
};

function RaceListPage() {
  const [races, setRaces] = useState([]);
  const [message, setMessage] = useState('');
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const fetchRaces = async () => {
      try {
        const response = await axios.get('/api/races/list');
        setRaces(response.data);
      } catch (error) {
        setMessage('Error fetching races: ' + (error.response?.data || error.message));
        console.error(error);
      }
    };

    const fetchUserStatus = async () => {
      try {
        const response = await axios.get('/api/users/status');
        setCurrentUser(response.data.user);
      } catch (error) {
        console.error('Error fetching user status:', error);
      }
    };

    fetchRaces();
    fetchUserStatus();
  }, []);

  const handleDelete = async (raceId) => {
    if (window.confirm('Are you sure you want to delete this race?')) {
      try {
        await axios.delete(`/api/races/${raceId}`);
        setRaces(races.filter((race) => race.id !== raceId));
        setMessage('Race deleted successfully!');
      } catch (error) {
        setMessage('Error deleting race: ' + (error.response?.data || error.message));
        console.error(error);
      }
    }
  };

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Available Races
      </Typography>
      {message && <p>{message}</p>}
      {races.length > 0 ? (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Race Name</TableCell>
                <TableCell>Location</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {races.map((race) => (
                <TableRow key={race.id}>
                  <TableCell>
                    {currentUser && checkRole(currentUser, ['admin', 'director', 'photographer']) ? (
                      <Link to={`/upload-image/${race.id}`} style={{ display: 'flex', alignItems: 'center' }}>
                        {race.name}
                        <FileUploadIcon sx={{ ml: 0.5 }} />
                      </Link>
                    ) : (
                      race.name
                    )}
                  </TableCell>
                  <TableCell>
                    {race.city}, {race.state}
                  </TableCell>
                  <TableCell>{new Date(race.date).toLocaleDateString()}</TableCell>
                  <TableCell>
                    <Button component={Link} to={`/races/${race.id}/images`} variant="outlined" size="small">
                      View Images
                    </Button>
                    {currentUser && checkRole(currentUser, ['admin', 'director']) && (
                      <>
                        <Button
                          component={Link}
                          to={`/edit-race/${race.id}`}
                          variant="outlined"
                          size="small"
                          style={{ marginLeft: '8px' }}
                        >
                          Edit
                        </Button>
                        <Button
                          component={Link}
                          to={`/generate-photographer-token?raceId=${race.id}`}
                          variant="outlined"
                          size="small"
                          style={{ marginLeft: '8px' }}
                        >
                          Invite Photographer
                        </Button>
                        <Button
                          variant="outlined"
                          size="small"
                          style={{ marginLeft: '8px' }}
                          onClick={() => handleDelete(race.id)}
                        >
                          Delete
                        </Button>
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <p>No races found.</p>
      )}
      {currentUser && checkRole(currentUser, ['admin', 'director']) && (
        <Button component={Link} to="/create-race" variant="contained" color="primary" style={{ marginTop: '16px' }}>
          Create Race
        </Button>
      )}
    </Container>
  );
}

export default RaceListPage;
